import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { ClientInfo } from '../types';
import { useTranslation } from '../i18n/i18n';
import LanguageSelector from './LanguageSelector';
import ClientLogo from './ClientLogo';

type TopBarProps = {
  client?: ClientInfo;
  onOpenSidebar: () => void;
};

/**
 * TopBar — Mobile-only top navigation bar.
 *
 * Figma (mobile): https://www.figma.com/design/6V1D3oNy17pfFNHIRb2nmm/Ronan-V2---UX?node-id=176-22554
 *
 * Shows: [hamburger button] [client logo / branding] [help button] [language flag]
 *
 * Hidden on desktop (md+) via CSS.
 */
export default function TopBar({ client, onOpenSidebar }: TopBarProps) {
  const { t } = useTranslation();

  return (
    <header className="flex sidebar:hidden items-center justify-between border-b border-border bg-background px-4 py-3">
      {/* Left: hamburger / sidebar toggle */}
      <div className="flex flex-1 items-center">
        <button
          type="button"
          onClick={onOpenSidebar}
          className="flex items-center justify-center size-10 rounded-md border border-input bg-background"
          aria-label={t('topBar.openMenu')}
        >
          <FontAwesomeIcon icon={faBars} className="size-4" />
        </button>
      </div>

      {/* Center: client branding */}
      <div className="flex items-center justify-center shrink-0">
        <ClientLogo client={client} />
      </div>

      {/* Right: language */}
      <div className="flex flex-1 items-center justify-end">
        <LanguageSelector compact />
      </div>
    </header>
  );
}
